import { render } from "./ShopItem.vue?vue&type=template&id=793fc00c&scoped=true&ts=true"
import script from "./ShopItem.vue?vue&type=script&lang=ts"
export * from "./ShopItem.vue?vue&type=script&lang=ts"

import "./ShopItem.vue?vue&type=style&index=0&id=793fc00c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793fc00c"]])

export default __exports__